/**
 * Copyright IBM Corp. 2022, 2026
 */

import Placeholder from 'components/materia/form/placeholder'
import { SkeletonForm } from '@hashicorp/mds-react/components'
import s from './form.module.css'

const PlaceholderWrapper = ({ size = 'lg' }) => {
	let placeholder = <SkeletonForm />

	switch (size) {
		// Use a variation of the older placeholder for smaller forms
		// because we can adjust its size more granularly than SkeletonForm
		case 'sm':
			placeholder = (
				<Placeholder>
					{(Box) => {
						return (
							<div className={s.loading} aria-hidden="true">
								<div className={s.desktop}>
									{/* Header */}
									<div className={s.passRow}>
										<Box
											width="16ch"
											fontSize="2.5rem"
											height="40px"
											marginBottom="48px"
										/>
										<Box width="10ch" height="48px" />
										<Box
											width="8ch"
											fontSize="2.5rem"
											height="40px"
											marginBottom="48px"
										/>
									</div>
								</div>
								<div className={s.mobile}>
									{/* Header/instruction */}
									<div className={s.passRow}>
										<Box
											width="16ch"
											fontSize="2.5rem"
											height="40px"
											marginBottom="48px"
										/>
										<Box width="10ch" height="48px" />
										<Box
											width="4ch"
											fontSize="2.5rem"
											height="40px"
											marginBottom="48px"
										/>
									</div>
								</div>
							</div>
						)
					}}
				</Placeholder>
			)
			break
		case 'lg':
		default:
			break
	}

	return <>{placeholder}</>
}

export default PlaceholderWrapper
